module.exports = __webpack_public_path__ + "static/media/S20-0967_F_C_Hompage_2396x1473_FR.75069295.jpg";